import firebase from 'firebase/app'
import 'firebase/firestore'
const firebaseConfig = {
    apiKey: "AIzaSyCvnun0GmfNXneQlEkB7tfJgFCyvcsRx8U",
    authDomain: "teams-racing-mbsc.firebaseapp.com",
    databaseURL: "https://teams-racing-mbsc.firebaseio.com",
    projectId: "teams-racing-mbsc",
    storageBucket: "teams-racing-mbsc.appspot.com",
    messagingSenderId: "219363300851",
    appId: "1:219363300851:web:8c42e100c26676c2f7ee86"
};
// Get a Firestore instance
export const db = firebase
    .initializeApp(firebaseConfig)
    .firestore()

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { Timestamp, GeoPoint } = firebase.firestore
export { Timestamp, GeoPoint }
